export const all_routes = {
  // *************************************** FRONT END ROUTS LIST ****************************************

  // 1. ADMIN APP

  // Login
  login: "/login",

  // Dashboard & bussiness routes
  dashboard: "/",
  dashboardAdmin: "/admin-dashboard",
  // dashboardWebsite: "/website-dashboard",

  // Summary routes
  expences: "/expenses",
  orderSummary: "/order-summary",
  performanceReport: "/performance-report",
  saleReport: "/financial-report",
  quotationSummary: "/quotation-summary",

  // Sales routes
  quotation: "/quotation-detail",
  order: "/order",
  partialOrder: "/partial-order",
  report: "/report",
  invoice: "/invoice",
  quotationReport: "/quotation-report",
  orderReport: "/order-report",

  // Clients & user routes
  owner: "/owner",
  customer: "/customer",
  user: "/user",
  roleAcess: "/role-access",

  // Products  routes
  product: "/product",
  parameter: "/parameter",
  usp: "/usp",
  brand: "/brand",
  category: "/category",

  // Support routes
  ticket: "/ticket",
  faq: "/faq",
  contactRequest: "/contact-request",

  // Configuration routes
  quotationFormat: "/quotation-format",
  principal: "/principal",
  reason: "/reason",
  notifications: "/notifications",

  // Vendords routes
  source: "/source",
  supplier: "/supplier",
  courier: "/courier",
  pageNotFound: "/404",

  // Profile details
  profileDetails: "/profile-details",

  pushNotification: "/notification",
  // *************************************** BANCKEND  ROUTS LIST ****************************************
  backend: {
    // Login
    login: "/login",
    logout: "/logout",

    // Courier
    addUpdateCourier: "/addUpdateCourier",
    getCourier: "/getCourier",
    deleteCourier: "/deleteCourier",

    // Get Dropdown
    getBranchDD: "/getBranchDD",
    getPrincipalTypeDD: "/getPrincipalTypeDD",
    getPrincipalDD: "/getPrincipalDD",
    getParameterFieldDD: "/getParameterFieldDD",
    getUpsCategoryDD: "/getUpsCategoryDD",
    getCountryDD: "/getCountryDD",
    getStateDD: "/getStateDD",
    getOwnerDD: "/getOwnerDD",
    getClassificationDD: "/getClassificationDD",
    getExpansedClassificationDD: "/getExpansedClassificationDD",
    getBrandDD: "/getBrandDD",
    getCategoryDD: "/getCategoryDD",
    getProductDD: "/getProductDD",
    getSourceDD: "/getSourceDD",
    getCurrencyDD: "/getCurrencyDD",
    getCompanyDD: "/getCompanyDD",
    getQuotationType: "/getQuotationType",
    getQuotationTypeDD: "/getQuotationTypeDD",
    getNotificationDD: "/getNotificationDD",
    getPaymentAdvanceDD: "/getPaymentAdvanceDD",
    getStatusDD: "/getStatusDD",
    getCourierDD: "/getCourierDD",
    getRoleDD: "/getRoleDD",
    getOrderStatusDD: "/getOrderStatusDD",
    getQuotationFormatDD: "/getQuotationFormatDD",

    // Quotation format
    addUpdateQuotationFormat: "/addUpdateQuotationFormat",
    getQuotationFormat: "/getQuotationFormat",
    deleteQuotationFormat: "/deleteQuotationFormat",

    // Principal
    addUpdatePrincipal: "/addUpdatePrincipal",
    getPrincipal: "/getPrincipal",
    deletePrincipal: "/deletePrincipal",

    // Notificaion
    addUpdateNotification: "/addUpdateNotification",
    getNotification: "/getNotification",
    deleteNotification: "/deleteNotification",

    // Parameter
    addUpdateParameter: "/addUpdateParameter",
    getParameter: "/getParameter",
    deleteParameter: "/deleteParameter",

    // Category
    addUpdateCategory: "/addUpdateCategory",
    getCategory: "/getCategory",
    deleteCategory: "/deleteCategory",
    getCategoryParameterDD: "/getCategoryParameterDD",
    getCategoryParams: "/getCategoryParams",

    // Source
    addUpdateSource: "/addUpdateSource",
    getSource: "/getSource",
    deleteSource: "/deleteSource",

    // Brand
    addUpdateBrand: "/addUpdateBrand",
    getBrand: "/getBrand",
    deleteBrand: "/deleteBrand",

    // Reason
    addUpdateReason: "/addUpdateReason",
    getReason: "/getReason",
    deleteReason: "/deleteReason",

    // USP
    addUpdateUSP: "/addUpdateUSP",
    getUSP: "/getUSP",
    deleteUSP: "/deleteUSP",

    // Owner
    addUpdateOwner: "/addUpdateOwner",
    getOwner: "/getOwner",
    deleteOwner: "/deleteOwner",

    // Customer
    addUpdateCustomer: "/addUpdateCustomer",
    getCustomer: "/getCustomer",
    deleteCustomer: "/deleteCustomer",

    // Product
    addUpdateProduct: "/addUpdateProduct",
    getProduct: "/getProduct",
    deleteProduct: "/deleteProduct",
    uploadProductFile: "/uploadProductFile",
    importStatus: "/importStatus",

    // User
    addUpdateUser: "/addUpdateUser",
    getUser: "/getUser",
    deleteUser: "/deleteUser",

    // Supplier
    addUpdateSupplier: "/addUpdateSupplier",
    getSupplier: "/getSupplier",
    deleteSupplier: "/deleteSupplier",

    // Quotation
    addUpdateQuotation: "/addUpdateQuotation",
    getQuotation: "/getQuotation",
    deleteQuotation: "/deleteQuotation",
    updateQuotationStatus: "/updateQuotationStatus",
    quotationPdfStatus: "/quotationPdfStatus",

    // Order
    storeOrder: "/storeOrder",
    getOrder: "/getOrder",
    deleteOrder: "/deleteOrder",
    addOrderReason: "/addOrderReason",
    orderPdfStatus: "/orderPdfStatus",

    // Partial order
    storePartialOrder: "/storePartialOrder",
    getPartialOrder: "/getPartialOrder",

    // Role & permission
    addUpdateRole: "/addUpdateRole",
    listPermissions: "/listPermissions",
    listRolesWithPermissions: "/listRolesWithPermissions",
    deleteRole: "/deleteRole",
    updateRole: "/updateRole",
    getRoles: "/getRoles",
    rolesPermissionsOverview: "/rolesPermissionsOverview",

    // Invoice
    getInvoice: "/getInvoice",
    addUpdateInvoice: "/addUpdateInvoice",
    deleteInvoice: "/deleteInvoice",

    // Profile
    updateProfile: "/updateProfile",
    getProfile: "/getProfile",
    updatePassWword: "/updatePassWword",

    // Quoation Summary Report
    quotationStatusReport: "/quotationStatusReport",
    quotationBranchReport: "/quotationBranchReport",
    quotationOwnerReport: "/quotationOwnerReport",
    quotationPrincipalDealerReport: "/quotationPrincipalDealerReport",
    filterQuotationSummary: "/filterQuotationSummary",

    // Order Summary Report
    principalWiseOrder: "/principalWiseOrder",
    companyWiseOrder: "/companyWiseOrder",
    branchWiseOrders: "/branchWiseOrders",
    statusWiseOrders: "/statusWiseOrders",
    pendingDispatchReasons: "/pendingDispatchReasons",

    // Sale report
    getSaleReport: "/getSaleReport",
    importPerformanceReport: "/importPerformanceReport",
    exportSaleData: "/exportSaleData",
    importSaleData: "/importSaleData",
    saleImportImportStatus: "/saleImportImportStatus",
    branchSummaryReport: "/branchSummaryReport",
    principalSummaryReport: "/principalSummaryReport",
    customerSummaryReport: "/customerSummaryReport",
    categorySummaryReport: "/categorySummaryReport",
    authorisedSummaryReport: "/authorisedSummaryReport",
    branchSummaryExport: "/branchSummaryExport",

    // Loadding dashboard
    todayOrdersKpi: "/todayOrdersKpi",
    todayQuotationKpi: "/todayQuotationKpi",
    todayPrincipalOrdersKpi: "/todayPrincipalOrdersKpi",
    todayPartialOrdersKpi: "/todayPartialOrdersKpi",
    topCompaniesByWeekday: "/topCompaniesByWeekday",
    topPrincipalsMonthWise: "/topPrincipalsMonthWise",
    topProductsCurrentMonth: "/topProductsCurrentMonth",

    // Notification

    markAllRead: "/markAllRead",
    markRead: "/markRead",
    notifications: "/notifications",
    pollNotifications: "/pollNotifications",
    getNotificationsList: "/getNotificationsList",
    getNotificationEntityTypes: "/getNotificationEntityTypes",

    // Testing PDF
    download: "/donwload",

    // Expanses
    addNewExpanses: "/addNewExpanses",
    addUpdateExpances: "/addUpdateExpances",
    addUpdateTravelExpense: "/addUpdateTravelExpense",
    addUpdateLinkOrder: "/addUpdateLinkOrder",
    addUpdateBillPayment: "/addUpdateBillPayment",
    addUpdateServiceReport: "/addUpdateServiceReport",
    getExpansesHistory: "/getExpansesHistory",
    deleteExpanses: "/deleteExpanses",
    getExpansesDetails: "/getExpansesDetails",

    updateInvoiceStatus: "/updateInvoiceStatus",
    deleteSaleRecords: "/deleteSaleRecords",
  },
};
